import {
  IdentityTeamTypeAriResourceOwner,
  IdentityTeamTypeAriResourceType
} from "./chunk-AKUNVL34.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/identity/team-type/manifest.ts
var identityTeamTypeAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: IdentityTeamTypeAriResourceOwner,
  resourceType: IdentityTeamTypeAriResourceType,
  resourceIdSlug: "{directoryId}/{teamTypeId}",
  resourceIdSegmentFormats: {
    directoryId: /[a-zA-Z0-9\-]+/,
    // eslint-disable-line no-useless-escape
    teamTypeId: /[a-zA-Z0-9.\-_~]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/identity/team-type/index.ts
var IdentityTeamTypeAri = class _IdentityTeamTypeAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._directoryId = opts.resourceIdSegmentValues.directoryId, this._teamTypeId = opts.resourceIdSegmentValues.teamTypeId;
  }
  get directoryId() {
    return this._directoryId;
  }
  get teamTypeId() {
    return this._teamTypeId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: identityTeamTypeAriStaticOpts.qualifier,
      platformQualifier: identityTeamTypeAriStaticOpts.platformQualifier,
      cloudId: void 0,
      resourceOwner: identityTeamTypeAriStaticOpts.resourceOwner,
      resourceType: identityTeamTypeAriStaticOpts.resourceType,
      resourceId: `${opts.directoryId}/${opts.teamTypeId}`,
      resourceIdSegmentValues: {
        directoryId: opts.directoryId,
        teamTypeId: opts.teamTypeId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, identityTeamTypeAriStaticOpts);
    return new _IdentityTeamTypeAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, identityTeamTypeAriStaticOpts);
    return new _IdentityTeamTypeAri(opts);
  }
  getVariables() {
    return {
      directoryId: this.directoryId,
      teamTypeId: this.teamTypeId
    };
  }
};

export {
  IdentityTeamTypeAri
};
